import React from "react";
import { observer } from "mobx-react";
import { PublisherRepresentativeViewStore } from "../../store";
import { PublisherRepresentativeViewForm } from "./PublisherRepresentativeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PublisherRepresentativeViewProps = {
  publisherRepresentativeViewStore: PublisherRepresentativeViewStore;
};

export const PublisherRepresentativeView: React.FC<PublisherRepresentativeViewProps> =
  observer(({ publisherRepresentativeViewStore }) => {
    return (
      <div>
        <PublisherRepresentativeViewForm
          name={publisherRepresentativeViewStore.nameValue}
          role={publisherRepresentativeViewStore.roleValue}
          email={publisherRepresentativeViewStore.emailValue}
          phone={publisherRepresentativeViewStore.phoneValue}
          isSigner={publisherRepresentativeViewStore.isSignerValue}
          onPrint={(handlePrint: () => void) =>
            publisherRepresentativeViewStore.printPublisherRepresentative(
              handlePrint
            )
          }
          onCancel={() =>
            publisherRepresentativeViewStore.cancelPublisherRepresentative()
          }
          onEdit={
            publisherRepresentativeViewStore.isEditEnabled
              ? () =>
                  publisherRepresentativeViewStore.editPublisherRepresentative()
              : undefined
          }
        />
        <ErrorDialog
          open={publisherRepresentativeViewStore.errorDialogOpened}
          title={publisherRepresentativeViewStore.errorTitle}
          description={publisherRepresentativeViewStore.errorDescription}
          onClose={() => publisherRepresentativeViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
